export {
    Type,
    instanceOf,
    fromMillis,
    fromString,
    toMillis,
    JSON_DISCRIMINATOR,
    Serializable,
    toTypedJSON,
    toUnwrappedJSON,
    fromUnwrappedJSON,
    fromTypedJSON,
    toSchemaValue,
    fromSchemaValue,
    SchemaValue,
    toSerializable,
    fromSerializable,
} from '../../types/Duration.js';
